import Layout from "../components/Layout";
import PurityTesting from "../components/_PurityTesting";

const PurityTestingPage = (props:any) => {
    return (
    <Layout>
        <PurityTesting />
    </Layout>
    )
}

export default PurityTestingPage